module.exports = __webpack_public_path__ + "img/official.8ef5765c.png";